export default function PrivacyRoute() {
	return (
		<main className="min-h-[calc(100vh-8rem)] bg-gradient-to-b from-[#05050a] via-[#070712] to-[#0a001f] text-[#f8f8ff]">
			<section className="container mx-auto px-6 py-16">
				<div className="max-w-3xl rounded-3xl border border-[#1a1a2e] bg-[#0d0d15] p-8 shadow-[0_0_30px_rgba(66,42,213,0.12)] sm:p-10">
					<p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#00e0ff]">
						Privacy
					</p>
					<h1 className="mt-4 text-4xl font-black tracking-tight text-[#f8f8ff]">
						Privacy policy
					</h1>
					<p className="mt-4 text-lg leading-8 text-[#b0b0e0]">
						This page now uses the same dark brand shell as the rest of the site instead
						of falling back to a neutral grey background.
					</p>
				</div>
			</section>
		</main>
	)
}
